"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var blockstack_1 = require("blockstack");

exports.COLLECTION_GAIA_PREFIX = 'collection';
exports.COLLECTION_SCOPE_PREFIX = 'collection.';

var Collection = /*#__PURE__*/function () {
  function Collection() {
    var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Collection);

    var schema = this.constructor.schema;
    this.schema = schema;
    this.attrs = Object.assign({}, attrs);
    this.defineDynamicGetterSetters(this.schema, this.attrs);
  }
  /**
   * Define the getter and setters for each attribute in the schema
   */


  _createClass(Collection, [{
    key: "defineDynamicGetterSetters",
    value: function defineDynamicGetterSetters(schema) {
      var _this = this;

      var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _loop = function _loop(key) {
        Object.defineProperty(_this, key, {
          get: function get() {
            return _this.attrs[key];
          },
          set: function set(value) {
            if (_this.attrs[key] !== value) {
              _this.attrs[key] = value;

              _this.onValueChange(key, value);
            }
          }
        });
      };

      for (var key in schema) {
        _loop(key);
      }
    }
    /**
     * Invoked when a property changes, subclass this to observe object property changes
     */

  }, {
    key: "onValueChange",
    value: function onValueChange(key, value) {
      return;
    }
    /**
     * Returns the collection type name
     *
     * @returns Returns the collection type name as a string
     */

  }, {
    key: "collectionName",

    /**
     * Returns the collection type name
     *
     * @returns Returns the collection type name as a string
     */
    value: function collectionName() {
      throw new Error('Required abstract method collectionName was not implemented');
    }
    /**
     * Returns an instance of the collection object created from input data
     *
     * @returns Returns a collection object
     */

  }, {
    key: "save",

    /**
     * Stores the collection object to collection data store.
     * @param {UserSession} userSession? - Optional user session object
     *
     * @returns {Promise} that resolves to the object identifier if the operation succeed
     * and rejects if it failed
     */
    value: function save(userSession) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var config, hubConfig, identifier, file, normalizedIdentifier, opt;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                userSession = userSession || new blockstack_1.UserSession();
                _context.next = 3;
                return userSession.getCollectionConfigs(this.collectionName());

              case 3:
                config = _context.sent;
                hubConfig = config.hubConfig;
                identifier = this.constructIdentifier();
                this.attrs.identifier = identifier;
                file = this.serialize();
                normalizedIdentifier = exports.COLLECTION_GAIA_PREFIX + '/' + identifier;
                opt = {
                  gaiaHubConfig: hubConfig,
                  encrypt: blockstack_1.getPublicKeyFromPrivate(config.encryptionKey)
                };
                return _context.abrupt("return", blockstack_1.putFile(normalizedIdentifier, file, opt, userSession).then(function () {
                  return identifier;
                }));

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
    /**
     * Deletes the object from the collection.
     * @param {UserSession} userSession? - Optional user session object
     *
     * @returns Resolves when the file has been removed or rejects with an error.
     */

  }, {
    key: "delete",
    value: function _delete(userSession) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var config, hubConfig, opt, normalizedIdentifier;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                userSession = userSession || new blockstack_1.UserSession();
                _context2.next = 3;
                return userSession.getCollectionConfigs(this.collectionName());

              case 3:
                config = _context2.sent;
                hubConfig = config.hubConfig;
                opt = {
                  gaiaHubConfig: hubConfig
                };
                normalizedIdentifier = exports.COLLECTION_GAIA_PREFIX + '/' + this.attrs.identifier;
                return _context2.abrupt("return", blockstack_1.deleteFile(normalizedIdentifier, opt, userSession));

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }], [{
    key: "fromData",
    value: function fromData(data) {
      throw new Error('Required abstract method fromData was not implemented');
    }
    /**
     * Retrieves a collection object from the collection data store
     * @param {String} identifier - The identifier of the collection object to retrieve
     * @param {UserSession} userSession? - Optional user session object
     *
     * @returns {Promise} that resolves to the a collection obbject or rejects with an error
     */

  }, {
    key: "get",
    value: function get(identifier, userSession) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this2 = this;

        var config, hubConfig, normalizedIdentifier, opt;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                userSession = userSession || new blockstack_1.UserSession();
                _context3.next = 3;
                return userSession.getCollectionConfigs(this.collectionName);

              case 3:
                config = _context3.sent;
                hubConfig = config.hubConfig;
                normalizedIdentifier = exports.COLLECTION_GAIA_PREFIX + '/' + identifier;
                opt = {
                  gaiaHubConfig: hubConfig,
                  decrypt: config.encryptionKey
                };
                return _context3.abrupt("return", blockstack_1.getFile(normalizedIdentifier, opt, userSession).then(function (fileContent) {
                  if (fileContent) {
                    return _this2.fromData(fileContent);
                  } else {
                    throw new Error('Collection item not found');
                  }
                }));

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
    /**
     * List the objects in a collection
     * @param {function} callback - a callback to invoke on each object identifier that
     * returns `true` to continue the listing operation or `false` to end it
     *
     * @returns {Promise} that resolves to the number of objects listed
     */

  }, {
    key: "list",
    value: function list(callback, userSession) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var config, hubConfig;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                userSession = userSession || new blockstack_1.UserSession();
                _context4.next = 3;
                return userSession.getCollectionConfigs(this.collectionName);

              case 3:
                config = _context4.sent;
                hubConfig = config.hubConfig;
                return _context4.abrupt("return", blockstack_1.listFilesLoop(userSession, hubConfig, null, 0, 0, false, function (path) {
                  var collectionGaiaPathPrefix = exports.COLLECTION_GAIA_PREFIX + '/';

                  if (path.startsWith(collectionGaiaPathPrefix)) {
                    // Remove collection/ prefix from file names
                    var identifier = path.substr(collectionGaiaPathPrefix.length);
                    return callback(identifier);
                  } else {
                    // Skip non-collection prefix files
                    return true;
                  }
                }));

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
    /**
     * Deletes the object from the collection.
     * @param {String} identifier - The identifier of the collection object to delete
     * @param {UserSession} userSession? - Optional user session object
     *
     * @returns Resolves when the file has been removed or rejects with an error.
     */

  }, {
    key: "delete",
    value: function _delete(identifier, userSession) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var config, hubConfig, opt, normalizedIdentifier;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                userSession = userSession || new blockstack_1.UserSession();
                _context5.next = 3;
                return userSession.getCollectionConfigs(this.collectionName);

              case 3:
                config = _context5.sent;
                hubConfig = config.hubConfig;
                opt = {
                  gaiaHubConfig: hubConfig
                };
                normalizedIdentifier = exports.COLLECTION_GAIA_PREFIX + '/' + identifier;
                return _context5.abrupt("return", blockstack_1.deleteFile(normalizedIdentifier, opt, userSession));

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "collectionName",
    get: function get() {
      throw new Error('Required abstract method collectionName was not implemented');
    }
    /**
     * Returns the collection scope string
     *
     * @returns Returns the collection scope string
     */

  }, {
    key: "scope",
    get: function get() {
      return "".concat(exports.COLLECTION_SCOPE_PREFIX).concat(this.collectionName);
    }
  }]);

  return Collection;
}();

exports.Collection = Collection;
Collection.schemaVersion = '1.0';
Collection.schema = {
  identifier: String
};